<template>
  <div class="loyalty-hero-container">
    <div class="hero-image"></div>
    <div class="text-container container">
      <h1>{{ heading }}</h1>
    </div>
  </div>

  <div class="container">
    <div class="slot"><slot /></div>

    <div class="button-container">
      <div class="login-button">
        <Button
          type="button"
          full-width
          theme="primary"
          @click="setSlideLogin(true)"
        >
          LOGIN
        </Button>
      </div>
      <div class="sign-up-button">
        <Button
          type="button"
          full-width
          theme="primary"
          @click="setSlideSignUp(true)"
        >
          SIGN UP
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { mapActions } from "vuex";

export default {
  name: "LoyaltyHero",
  components: {
    Button,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.loyalty-hero-container {
  position: relative;
  text-align: center;
}

.hero-image {
  height: 300px;
  background-position: center center;
  background-repeat: none;
  background-image: url("@/assets/images/loyalty/hero-small.jpg");

  @include respond-above(sm) {
    height: 468px;
    background-image: url("@/assets/images/loyalty/hero-medium.jpg");
  }

  @include respond-above(md) {
    background-size: cover;
    background-position: top center;
    background-image: url("@/assets/images/loyalty/hero-large.jpg");
    height: 80vh;
  }
}

.text-container {
  @include respond-above(md) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: $color-white;
  }
}

h1 {
  font-family: $heading-font-family;
  font-size: 30px;
  font-weight: 400;
  margin: 30px 0 20px;
  text-align: center;
  @include respond-above(md) {
    font-size: 80px;
    margin: 0;
  }
}

.slot {
  ::v-deep(p) {
    font-family: $heading-font-family;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 30px;
    text-align: center;
    @include respond-above(md) {
      font-size: 18px;
      margin: 40px auto 30px;
      max-width: 452px;
    }
  }
}

.button-container {
  display: flex;
  margin-bottom: 60px;
  justify-content: center;
  column-gap: 10px;
  @include respond-above(md) {
    margin-bottom: 80px;
  }
}

.login-button {
  width: 100%;
  @include respond-above(md) {
    max-width: 221px;
  }
}

.sign-up-button {
  width: 100%;
  @include respond-above(md) {
    max-width: 221px;
  }
}
</style>
